import {
  ADD_OPENED_CONTENT,
  VIEW_IMG,
  VIEW_VIDEO,
} from "~/constants/apiEndpoints";
import { apiClient } from "~/lib/apiClient";

/** 画像を閲覧済みとしてマークする（ポイント消費） */
export const viewImageRequest = async (imgId: string): Promise<void> => {
  await apiClient<unknown>(VIEW_IMG, { img_id: imgId });
};

/** 動画を閲覧済みとしてマークする（ポイント消費） */
export const viewVideoRequest = async (videoId: string): Promise<void> => {
  await apiClient<unknown>(VIEW_VIDEO, { video_id: videoId });
};

/** 開封済みコンテンツとして登録（ギャラリーに表示されるようにする） */
export const addOpenedContentRequest = async (
  fileId: string,
  isImage: boolean,
): Promise<void> => {
  await apiClient<unknown>(ADD_OPENED_CONTENT, {
    file_id: fileId,
    is_image: isImage,
    opened_content_type: isImage ? "image" : "video",
  });
};
